import React, { useMemo } from 'react';
import Tooltip from '../../../../Components/Popup/Tooltip';
import { MonitoringCenterCase } from '../MonitoringCenterListTable/MonitoringCenterListTable';

interface Props {
	item: MonitoringCenterCase;
}

const MonitoringCenterLabelColumn: React.FC<Props> = ({ item }) => {
	return useMemo(() => {
		if (
			item.caseType?.code === 'permanent_medication' &&
			item.medicationLasted &&
			(item.medicationLasted.length || 0) > 0
		) {
			return (
				<Tooltip trigger={item.caseType.label}>
					{item.medicationLasted.map((item, key) => (
						<div key={key}>{item.value}</div>
					))}
				</Tooltip>
			);
		}
		return item?.caseType?.rootCaseType?.label ?? item.caseType?.label;
	}, [item]);
};

export default MonitoringCenterLabelColumn;
